import {
    TextInput,
    Anchor,
    Paper,
    Title,
    Text,
    Container,
    Button,
} from '@mantine/core';
import logo from '../../assets/Long_logo_dark.svg';
import { useEffect, useState, useRef } from 'react';
import axios from '../../api/axios.js'
import useAuth from '../../hooks/useAuth';

const USER_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
const PWD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%]).{8,24}$/;
const RESET_URL = '/password';

export default function ForgotPassword() {

    const { persist, setPersist } = useAuth();

    const userRef = useRef();
    const errRef = useRef();

    const [user, setUser] = useState('');
    const [validName, setValidName] = useState(false);

    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        setValidName(USER_REGEX.test(user));
    }, [user])

    useEffect(() => {
        setErrMsg('');
    }, [user])

    const togglePersist = () => {
        setPersist(prevState => !prevState);
    }

    useEffect(() => {
        localStorage.setItem("persist", persist);
    }, [persist])

    const handleSubmit = async (e) => {
        e.preventDefault();

        const v1 = USER_REGEX.test(user);
        if (!v1) {
            setErrMsg("Invalid Entry");
            return;
        }

        const response = await axios.post(RESET_URL,
            JSON.stringify({ user }),
            {
                headers: { 'Content-Type': 'application/json' },
                withCredentials: true
            });
        setSuccess(true);
    }

    return (
        <>
            {success ? (
                <Container size={420} my={40}>
                    <Title ta="center">
                        Request successful! We have sent the password reset link to your Email address.
                    </Title>
                    <Text c="dimmed" size="sm" ta="center" mt={5}>
                        Go to the login page{' '}
                        <Anchor size="sm" component="a" href="/login">
                            Login
                        </Anchor>
                    </Text>
                </Container>
            ) : (
                <Container size={420} my={40}>
                    {/* <Image width={100} height={100} src={logo} align="center" alt="ResiRent logo" /> */}
                    <Title ta="center">
                        Password Reset
                    </Title>
                    <Text c="dimmed" size="sm" ta="center" mt={5}>
                        Back to{' '}
                        <Anchor size="sm" component="a" href="/login">
                            Login
                        </Anchor>
                    </Text>

                    <form onSubmit={handleSubmit}>
                        <Paper withBorder shadow="md" p={30} mt={30} radius="md">
                            <TextInput
                                label="Email"
                                placeholder="name@name.com"
                                required
                                value={user}
                                onChange={(e) => setUser(e.target.value)} />

                            <Button type="submit" variant="outline" color="resirent" fullWidth mt="lg" disabled={!validName}>
                                Request Password Change
                            </Button>

                        </Paper>

                    </form>
                </Container >
            )}
        </>
    );
}